<template>
  <div id="app">
    <MyGallinasPage></MyGallinasPage>
  </div>
</template>

<script>
import MyGallinasPage from '../components/MyGallinasPage.vue'

export default {
  name: 'MyGallinas',
  components: {
    MyGallinasPage
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
